import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { SocialLink } from '@bd/bdcore-utilities';
import { colors } from '../styles';
import OSCTagMobile from './OSCTagMobile';

const styles = css`
.Footer_content {
  font-size: 14px;
  padding: 40px 0 60px 0;
  background-color: #F5F5F5;
  text-align: center;
  @media (min-width: 992px) {
    text-align: left;
    padding: 40px 0 0 0;
  }
}
.Footer_logo {
  width: 50%;
  display: block;
  margin: 0 auto 15px auto;
}
.Footer_socialLinks {
  padding: 0;
  margin: 30px 0;
  text-align: center;
  li {
    display: inline-block;
    margin: 0 0 0 20px;
    a img {
      height: 20px;
      width: auto;
      filter: brightness(80%);
    }
  }
  @media (min-width: 992px) {
    text-align: right;
  }
}
.Footer_menu {
  display: none;
  @media (min-width: 992px) {
    display: inline-block;
    padding: 0;
    margin: 0 20px 50px 0;
    vertical-align: top;
    list-style: none;
    li {
      font-weight: 400;
      line-height: 24px;
      a {
        color: #333333;
        font-weight: 400;
      }
    }
    .menu-heading {
      color: ${colors.color2};
      font-weight: 700;
    }
  }
  @media (min-width: 1201px) {
    margin: 0 50px 50px 0;
  }
}
.Footer_contactInfo {
  text-align: center;
  color: #333333;
}
.Footer_EHOLogo {
  display: block;
  margin: 10px auto;
  @media (min-width: 992px) {
    display: inline-block;
    margin: -4px 0 0 10px;
    height: 18px;
    width: auto;
  }
}
.Footer_copyright {
  text-align: center;
  padding: 20px 30px;
  background-color: #eeeeee;
  margin: 20px 0 0 0;
  color: #333333;
  a {
    color: ${colors.color2};
  }
}
`;

function Footer({ builder }) {
  return (
    <div className={styles}>
      <div className="Footer_wrapper">
        <div className="Footer_inner">
          <div className="Footer_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-10">
                  <ul className="Footer_menu">
                    <li className="menu-heading">Find Your Home</li>
                    <li><Link name="community-map">Community Map & Lots</Link></li>
                    <li><Link name="homes">Quick Move-In Homes</Link></li>
                    <li><Link name="plans">Floor Plans</Link></li>
                    <li><Link name="model-homes">Model Homes Showcase</Link></li>
                  </ul>
                  <ul className="Footer_menu">
                    <li className="menu-heading">Life at {get(builder, 'name') || 'Solera Reserve'}</li>
                    <li><Link name="community-overview">Community Overview</Link></li>
                    <li><Link name="amenities">Amenities</Link></li>
                    <li><Link name="about-the-area">About The Area</Link></li>
                    <li><Link name="map-and-directions">Map & Directions</Link></li>
                    {/* <li><Link name="testimonials">Testimonials</Link></li> */}
                  </ul>
                  <ul className="Footer_menu">
                    <li className="menu-heading">Galleries</li>
                    <li><Link name="photo-gallery">Photo Gallery</Link></li>
                    {/* <li><Link name="video-gallery">Video Gallery</Link></li> */}
                  </ul>
                  <ul className="Footer_menu">
                    <li className="menu-heading">Resources</li>
                    <li><Link name="design-center">Design Center</Link></li>
                    <li><Link name="hoa-request">Documents</Link></li>
                    <li><Link name="about-the-developer">About The Developer</Link></li>
                  </ul>
                  <ul className="Footer_menu">
                    <li className="menu-heading">Contact</li>
                    <li><Link name="contact-us">Contact Us</Link></li>
                    {/* <li><Link name="privacy-policy">Privacy Policy</Link></li>
                    <li><Link name="terms">Terms & Conditions</Link></li> */}
                    <li><Link name="hmls-terms">HMLS Terms of Use</Link></li>
                  </ul>
                </div>
                <div className="col-lg-2">
                  <p className="Footer_contactInfo">
                    <img className="Footer_logo" src={builder.logo.contentUrl} alt={get(builder, 'name')} />
                    {get(builder, 'address.streetAddress')}<br />
                    {get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.addressPostalCode')}<br />
                    P: <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}</a><br />
                  </p>
                  <ul className="Footer_socialLinks">
                    {
                      get(builder, 'socialLinks', []).map(link => (
                        <li key={link}>
                          <SocialLink
                            url={link}
                          />
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
            </div>
            <div className="Footer_copyright">
              ©2019 {get(builder, 'name')}. All Rights Reserved.
              Site By <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a>.
              <img className="Footer_EHOLogo"src="/images/icon-equal-housing.svg" alt="Equal Opportunity Housing Logo" />
            </div>
          </div>
        </div>
      </div>
      <OSCTagMobile />
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
})(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js